import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TextField,
  CircularProgress,
  FormControlLabel,
  Switch,
  Button,
  Select,
  MenuItem,
  Checkbox,
  IconButton,
  Box,
  ListItemIcon,
  Menu,
  ListItemText,
  Tooltip,
} from "@mui/material";
import colors from "../../../../assets/theme/light/colors";
import { Field } from "formik";
import { GET_ALL_PROJECTS_DROPDOWN } from "../../../../graphql/project";
import useAuth from "../../../../hooks/useAuth";
import { GET_ALL_TASKS_WITH_PROJECT, GET_FAVORITE_TASKS } from "../../../../graphql/task";
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import { v4 as uuidv4 } from "uuid";

import AutoComplete from "../../../../components/AutoComplete";
import { DeleteIcon, FilledStarIcon, VerticalActionsIcon } from "../../../../components/Icon";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import RoundedDatePicker from "../../../../components/DateField/RoundedDatePicker";
import { GET_TIME_ENTRIES } from "../../../../graphql/timeEntry";
import IALoadingButton from "../../../../components/IAButtons/IALoadingButton";
import { enqueueSnackbar } from "notistack";

export function TimesheetTable({
  t,
  formData,
  timeErrors,
  setTimeErrors,
  handleDate,
  isTimeEntryDescriptionMandatory,
}) {
  const [tasks, setTasks] = useState([]);
  const [fetchProjects, setFetchProjects] = React.useState(false);
  const [fetchTasksLoadingOpenDD, setFetchTasksLoadingOpenDD] = React.useState(false);
  const [focused, setFocused] = useState(null);
  const [rowID, setRowID] = useState(null);
  const { values } = formData;
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(new Set());
  const { storeUserTenant, storeUserGuid } = useAuth();

  const handleChangeDescription = (id, newDescription) => {
    const updatedTasks = tasks.map(task => {
      if (task.id === id) {
        return { ...task, description: newDescription };
      }
      return task;
    });

    setTasks(updatedTasks);
    values.tasks = updatedTasks;
  };
  const handleToggleTaskSelection = (id) => {
    setSelectedRowToDelete(prev => {
      const newSelection = new Set(prev);
      if (newSelection.has(id)) {
        newSelection.delete(id);
      } else {
        newSelection.add(id);
      }
      return newSelection;
    });
  };

  const handleDeleteTask = (taskId) => {
    const updatedTasks = tasks.filter(task => task.id !== taskId);

    const dates = updatedTasks.map(task => task.date);
    handleDate(dates);

    setTasks(updatedTasks);
    values.tasks = updatedTasks;
  };




  const handleChangeTime = (id, newTime) => {
    const regex = /^\d{0,3}(\.\d{0,2})?$/;
  
    if (newTime === "" || regex.test(newTime)) {
      const updatedTasks = tasks.map(task => {
        if (task.id === id) {
          const updatedTask = {
            ...task,
            duration: newTime,
          };
  
          setTimeErrors(prevErrors => {
            const updatedErrors = { ...prevErrors };
            if (newTime === "" || regex.test(newTime)) {
              delete updatedErrors[id];
            } else {
              updatedErrors[id] = "Invalid time format";
            }
            return updatedErrors;
          });
  
          return updatedTask;
        }
        return task;
      });
  
      setTasks(updatedTasks);
      values.tasks = updatedTasks;
    }
  };
  

  const nowDate = new Date();

  const handleChangeBillable = (id, billable) => {
    const updatedTasks = tasks.map(task => {
      if (task.id === id) { // Referencing by id
        return { ...task, billable: billable };
      }
      return task;
    });

    setTasks(updatedTasks);
    values.tasks = updatedTasks;
  };


  const {
    data: projectsData,
    loading: projectsLoading,
  } = useQueryAuth(GET_ALL_PROJECTS_DROPDOWN, "GetAllProjects", {
    variables: {
      model: {
        enableFilters: false,
        tenantID: storeUserTenant,
        userID: storeUserGuid,
        withAtLeastOneTask :true
      },
    },
    skip: !fetchProjects,
    isWait: fetchProjects
  });

  const projectsList = projectsData?.GetAllProjects?.projectsList?.projectViews || [];

  const {
    mfunction: getTasksWithProject,
    loading: tasksFetchLoading,
  } = useLazyQueryAuth(GET_ALL_TASKS_WITH_PROJECT, "GetTasks");

  const {
    mfunction: getFavoriteTasks,
    loading: favoriteTasksLoading,
    data: favoriteTasksData,
  } = useLazyQueryAuth(GET_FAVORITE_TASKS, "GetFavoriteTasksByEmployee");


  const {
    mfunction: getAllTimeEntries,
    data: timeEntriesData,
    loading,
    refetch: refetchData,
  } = useLazyQueryAuth(GET_TIME_ENTRIES, "GetTimeEntries");
  // useEffect(() => {
  //   if (selectedProject) {
  //     getTasksWithProject({
  //       variables: {
  //         model: {
  //           tenantID: storeUserTenant,
  //           enableFilters: false,
  //           userID: storeUserGuid,
  //           projectID: selectedProject.projectGuid,
  //           filters: { projectIDs },
  //           timeEntriesCreationAllowed: true,
  //         },
  //       },
  //     }, (response) => {
  //       setTaskList(response?.GetTasks?.tasks || []);
  //     });
  //   }
  // }, [selectedProject]);

  const [selectedTask, setSelectedTask] = useState(null);

  const addNewRow = () => {
    const newTask = {
      id: uuidv4(),
      project: '',
      description: '',
      duration: '0',
      billable: false,
      taskGuid: '',
      title: '',
      availabaleTasks: [],
      date: new Date(),
    };
    return newTask;

  };

  // useEffect to ensure there's always an empty row
  useEffect(() => {
    if (tasks.length === 0) {
      const newTask = addNewRow();
      setTasks([newTask]);
      handleDate([newTask.date]);
    }
  }, [tasks]);


  const handleAddNewRow = () => {
    setTasks([...tasks, addNewRow()]);
    const allDates = tasks.map(task => task.date);
    handleDate(allDates);
  };

  const handleChangeDate = (id, newDate) => {
    const updatedTasks = tasks.map(task => {
      if (task.id === id) {
        return { ...task, date: newDate };
      }
      return task;
    });
    const allDates = updatedTasks.map(task => task.date);
    setTasks(updatedTasks);
    handleDate(allDates);
    values.tasks = updatedTasks;
  };

  const handleChangeProject = (id, selectedProject) => {
    if (selectedProject) {
      fetchTasksForProject(id, selectedProject);
    } else {
      const updatedTasks = tasks.map(task => {
        if (task.id === id) {
          return { ...task, project: null, projectGuid: '', taskGuid: '', title: '', billable: false };
        }
        return task;
      });
      setTasks(updatedTasks);
      values.tasks = updatedTasks;
    }
  };

  const fetchTasksForProject = (rowId, selectedProject) => {
    getTasksWithProject({
      variables: {
        model: {
          tenantID: storeUserTenant,
          enableFilters: false,
          userID: storeUserGuid,
          projectID: selectedProject.projectGuid,
          timeEntriesCreationAllowed: true
        },
      },
    }, (response) => {
      const updatedTasks = tasks.map(task => {
        if (task.id === rowId) {
          return {
            ...task,
            availabaleTasks: response?.GetTasks?.tasks || [],
            project: selectedProject, // store the full object here
            projectGuid: selectedProject.projectGuid,
            taskGuid: task.taskGuid,
            title: task.title,
            billable: task.billable
          };
        }
        return task;
      });
      setTasks(updatedTasks);
      values.tasks = updatedTasks;
    });
  };

  const [disableFavoriteTasks, setDisableFavoriteTasks] = useState(false);
  const [disablePreviousDay, setDisablePreviousDay] = useState(false);



  const handleChangeTask = (id, newTask) => {
    const updatedTasks = tasks.map(task => {
      if (task.id === id) {
        return {
          ...task,
          taskGuid: newTask ? newTask.taskGuid : '',
          title: newTask ? newTask.title : '',
          billable:newTask? newTask.billable:false
        };
      }
      return task;
    });

    setTasks(updatedTasks);
    values.tasks = updatedTasks;
  };
  const redValue = "var(--color-error)";

  const handleGetFavoriteTasks = () => {

    // Ensure storeUserGuid is defined
    if (!storeUserGuid) {
      console.error("storeUserGuid is undefined");
      return;
    }

    getFavoriteTasks(
      { variables: { id: storeUserGuid } },
      (response) => {
        const favoriteData = response?.GetFavoriteTasksByEmployee;
        if (favoriteData && Array.isArray(favoriteData.favoriteTasks)) {
          if (favoriteData.favoriteTasks.length === 0) {
            enqueueSnackbar('No favorite tasks available', { variant: 'warning' });
            return; // Exit early if there are no tasks
          }
          const newRows = favoriteData.favoriteTasks.map(item => {
            const taskData = item.task;
            const projectData = taskData.ticket.project;
            return {
              id: uuidv4(),
              project: {
                title: projectData.title,
                projectGuid: projectData.projectGuid
              },
              projectGuid: projectData.projectGuid,
              taskGuid: taskData.taskGuid,
              title: taskData.title,
              description: "",
              duration: "0",
              billable: taskData.billable,
              availabaleTasks: [
                {
                  taskGuid: taskData.taskGuid,
                  title: taskData.title,
                  billable: taskData.billable,
                  ticket: taskData.ticket
                },
              ],
              date: new Date(),
            };
          });
          setTasks(prevTasks => {
            const filteredTasks = prevTasks.filter(task => {
              return !(
                task.project === '' &&
                task.taskGuid === '' &&
                task.title === '' &&
                task.description === '' &&
                task.duration === '0' &&
                task.billable === false
              );
            });
            const updatedTasks = [...filteredTasks, ...newRows];
            values.tasks = updatedTasks;
            handleDate(updatedTasks.map(t => t.date));
      
            setDisableFavoriteTasks(true)
            return updatedTasks;
          });
        } else {
          enqueueSnackbar('Error retrieving favorite tasks', { variant: 'error' });
        }
      })
  };

  const getPreviousBusinessDay = (date) => {
    const prevDate = new Date(date);
    const dayOfWeek = prevDate.getDay(); 
    if (dayOfWeek === 1) {
      prevDate.setDate(prevDate.getDate() - 3);
    } else if (dayOfWeek === 0) {
      prevDate.setDate(prevDate.getDate() - 3);
    } else {
      prevDate.setDate(prevDate.getDate() - 1);
    }
    return prevDate;
  };
  

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const formattedDate = yesterday.toDateString();

  const handleGetPreviousDay = () => {
  
    if (!storeUserGuid) {
      console.error("storeUserGuid is undefined");
      return;
    }
 
  
    getAllTimeEntries(
      {
        variables: {
          model: {
            userID: storeUserGuid,
            filters: {
              dateFrom: null,
              dateTo: new Date().toDateString(),
              employee: storeUserGuid,
              allowCreateTimeEntry: true,
              fromLastPrevious:true
            },
            enableFilters: true,
          },
        },
      },
      (response) => {
        const timeEntries =
          response?.GetTimeEntries?.timeEntriesList?.timeEntries;
        if (timeEntries && Array.isArray(timeEntries)) {
          if (timeEntries.length === 0) {
            enqueueSnackbar("You don't have previous time entries", {
              variant: "warning",
            });
            return;
          }
          const newRows = timeEntries.map((item) => {
            const { task, description, duration, billable } = item;
            const { project } = task.ticket;
            return {
              id: uuidv4(),
              project: {
                title: project.title,
                projectGuid: project.projectGuid,
              },
              projectGuid: project.projectGuid,
              taskGuid: task.taskGuid,
              title: task.title,
              description: "",
              duration: "0",
              billable: billable,
              availabaleTasks: [
                {
                  taskGuid: task.taskGuid,
                  title: task.title,
                  billable: billable,
                  ticket: task.ticket,
                },
              ],
              date: new Date(),
            };
          });
  
          setTasks((prevTasks) => {
            const filteredTasks = prevTasks.filter((task) => {
              return !(
                task.project === "" &&
                task.taskGuid === "" &&
                task.title === "" &&
                task.description === "" &&
                task.duration === "0" &&
                task.billable === false
              );
            });
            const updatedTasks = [...filteredTasks, ...newRows];
            values.tasks = updatedTasks;
            handleDate(updatedTasks.map((t) => t.date));
            setDisablePreviousDay(true);
            return updatedTasks;
          });
        } else {
          enqueueSnackbar('Error retrieving latest time entries', { variant: 'warning' });
        }
      }
    );
  };
  

  const duplicateRow = (existingTask) => {
    return {
      id: uuidv4(),
      project: existingTask.project,
      projectGuid: existingTask.projectGuid,
      taskGuid: existingTask.taskGuid,
      title: existingTask.title,
      availabaleTasks: existingTask.availabaleTasks,
      billable: existingTask.billable,
      date: existingTask.date,
      description: '',
      duration: '0',
    };

  };
  const handleMenuDuplicate = () => {
    const selectedTasks = tasks.filter((task) => selectedRowToDelete.has(task.id));
    const duplicatedTasks = selectedTasks.map((task) => duplicateRow(task));
    setTasks((prevTasks) => [...prevTasks, ...duplicatedTasks]);
    setSelectedRowToDelete(new Set());
  };

  const handleMenuDelete = () => {
    setTasks((prevTasks) => {
      const updatedTasks = prevTasks.filter(
        (task) => !selectedRowToDelete.has(task.id)
      );
      values.tasks = updatedTasks;
      return updatedTasks;
    });
    setSelectedRowToDelete(new Set());
  };


  const handleClickMenu = (event, task) => {
    setAnchorEl(event.currentTarget);
    setSelectedTask(task);
  };
  const handleCloseMenu = () => {
    setAnchorEl(false)
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);


  return (
    <>
      <div style={{ display: "flex", gap: "10px", paddingBottom: "10px", alignItems: "center" }}>
        <IALoadingButton
          onClick={handleGetFavoriteTasks}
          variant="contained"
          color="primary"
          style={{ position: "relative", paddingRight: "10px" }}
        >
          Fill From Favorite Tasks
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="yellow" stroke="yellow" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" strokeWidth="1.5" style={{ marginLeft: "5px" }}>
            <path d="M12 17.75l-6.172 3.245 1.179 -6.873-5 -4.867 6.9 -1 3.086 -6.253 3.086 6.253 6.9 1-5 4.867 1.179 6.873z"></path>
          </svg>
        </IALoadingButton>
        <IALoadingButton
          onClick={handleGetPreviousDay}
          variant="contained"
          color="primary"
          style={{ position: "relative", paddingRight: "10px" }}
        >
          Fill from Previous Day
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="yellow" strokeLinecap="round" strokeLinejoin="round" width="24" height="24" strokeWidth="1.5" style={{ marginLeft: "5px" }}>
            <path d="M19 5v6a3 3 0 0 1 -3 3h-7"></path>
            <path d="M13 10l-4 4 4 4m-5 -8l-4 4 4 4"></path>
          </svg>
        </IALoadingButton>
        {selectedRowToDelete.size > 0 && (
          <>
            {/* Spacer */}
            <div style={{ flexGrow: 1 }}></div>
            <Tooltip title={"Duplicate"}>
              <IconButton
                onClick={handleMenuDuplicate}
                variant="contained"
                color="primary"
                style={{ position: "relative", paddingRight: "10px" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" width="24" height="24" strokeWidth="2">
                <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
                </svg>
              </IconButton>
            </Tooltip>
            <Tooltip title={"Delete"}>
              <IconButton
                onClick={handleMenuDelete}
                variant="contained"
                color="primary"
                style={{ position: "relative", paddingRight: "10px" }}
              >
                <DeleteIcon color={redValue} />
              </IconButton>
            </Tooltip>
          </>
        )}
      </div>


      <Box sx={{ width: '100%', overflowX: 'auto' }}>
  <TableContainer
    component={Paper}
    className="table-timesheet-height"
    sx={{
      padding: "0 0 25px",
      maxHeight: { xs: 'auto', md: "60vh" },
      height: { xs: 'auto', md: "500px" },
      width: "100%",
    }}
  >
    {favoriteTasksLoading || loading ? (
      <Box sx={{ display: "flex", justifyContent: "center", margin: "40px" }}>
        <CircularProgress />
      </Box>
    ) : (
      <Table
        size="small"
        sx={{
          tableLayout: "auto",
          minWidth: "900px",
        }}
      >
        <TableHead sx={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
          <TableRow
            sx={{
              borderBottom: "1px solid var(--color--light-divider-color)",
              height: "42px !important",
            }}
          >
            <TableCell sx={{ width: { xs: "40px", sm: "50px" }, padding: "10px 4px" }}>
              <Checkbox
                checked={tasks.length > 0 && selectedRowToDelete.size === tasks.length}
                indeterminate={selectedRowToDelete.size > 0 && selectedRowToDelete.size < tasks.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    const allIDs = new Set(tasks.map((task) => task.id));
                    setSelectedRowToDelete(allIDs);
                  } else {
                    setSelectedRowToDelete(new Set());
                  }
                }}
              />
            </TableCell>
            <TableCell sx={{ width: "150px" }}>{t("myTimesheet.label.date")}</TableCell>
            <TableCell sx={{ minWidth: 200, width: { xs: "100%", md: "25%" } }}>
              {t("myTimesheet.column.project")}
            </TableCell>
            <TableCell sx={{ minWidth: 200, width: { xs: "100%", md: "25%" } }}>
              {t("myTimesheet.column.task")}
            </TableCell>
            <TableCell sx={{ minWidth: 200, width: { xs: "100%", md: "25%" } }}>
              {t("myTimesheet.column.description")}
            </TableCell>
            <TableCell sx={{ width: "80px" }}>
              {t("myTimesheet.column.time")}
            </TableCell>
            <TableCell sx={{ width: { xs: "40px", sm: "50px" }, display: { xs: "none", sm: "table-cell" } }}>
              {t("myTimesheet.column.billable")}
            </TableCell>
            <TableCell sx={{ width: "50px" }} />
          </TableRow>
        </TableHead>

        <TableBody>
          {tasks?.length === 0 ? (
            <TableRow sx={{ height: "42px !important" }}>
              <TableCell colSpan={10} align="center">
                No records to display
              </TableCell>
            </TableRow>
          ) : (
            tasks.map((task, index) => (
              <TableRow
                key={task.id}
                id={`row-${index}`}
                sx={{
                  backgroundColor: rowID === index ? colors.light_table_background_color : "white",
                }}
                selected={selectedRowToDelete.has(task.id)}
              >
                <TableCell sx={{ width: "50px", padding: "15px 4px" }}>
                  <Checkbox
                    checked={selectedRowToDelete.has(task.id)}
                    onChange={() => handleToggleTaskSelection(task.id)}
                  />
                </TableCell>

                {/* Date Picker */}
                <TableCell sx={{ width: "150px", padding: "4px" }}>
                  <RoundedDatePicker
                    multipleTimeEntry
                    label={t("myTimesheet.label.date")}
                    value={task.date}
                    onChange={(newValue) => handleChangeDate(task.id, newValue)}
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "13px !important", height: "16px" },
                      "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                        borderRadius: "4px !important",
                      },
                      "& .MuiInputLabel-root": { fontSize: "13px !important" },
                      "& .MuiSvgIcon-root": { fontSize: "20px !important" },
                    }}
                  />
                </TableCell>

                {/* Project AutoComplete */}
                <TableCell sx={{ minWidth: 200, padding: "4px" }}>
                  <AutoComplete
                    loading={projectsLoading}
                    options={projectsList}
                    getOptionLabel={(option) => option?.title || ""}
                    renderOption={(props, option) => <li {...props} key={uuidv4()}>{option.title}</li>}
                    onOpen={() => setFetchProjects(true)}
                    onClose={() => setFetchProjects(false)}
                    identifier={"projectGuid"}
                    size="small"
                    value={task?.project || null}
                    onChange={(e, newValue) => handleChangeProject(task.id, newValue)}
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "13px !important", height: "16px" },
                      "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                        borderRadius: "4px !important",
                      },
                    }}
                    label={t("reports.label.projects")}
                    roundedTextField
                  />
                </TableCell>

                {/* Task AutoComplete */}
                <TableCell sx={{ minWidth: 200, padding: "4px" }}>
                  <AutoComplete
                    loading={tasksFetchLoading || fetchTasksLoadingOpenDD}
                    options={
                      tasksFetchLoading || fetchTasksLoadingOpenDD
                        ? []
                        : task.availabaleTasks || []
                    }
                    getOptionLabel={(option) => option?.title || ""}
                    renderOption={(props, option) => <li {...props} key={uuidv4()}>{option.title}</li>}
                    identifier={"taskGuid"}
                    onChange={(e, newValue) => handleChangeTask(task.id, newValue)}
                    onOpen={() => {
                      if (task.project) {
                        setFetchTasksLoadingOpenDD(true);
                        fetchTasksForProject(task.id, task.project);
                        setFetchTasksLoadingOpenDD(false);
                      }
                    }}
                    onClose={() => setFetchTasksLoadingOpenDD(false)}
                    disabled={!task.projectGuid}
                    size="small"
                    value={
                      task.availabaleTasks?.find(t => t.taskGuid === task.taskGuid) || ""
                    }
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "13px !important", height: "16px" },
                      "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                        borderRadius: "4px !important",
                      },
                    }}
                    label={t("reports.label.tasks")}
                    roundedTextField
                  />
                </TableCell>

                {/* Description */}
                <TableCell 
                    sx={{  minWidth: 200, padding: "4px" }}>
                  <TextField
                    multiline
                    fullWidth
                    value={task.description}
                    sx={{
                   //   padding: "10 !important",

                      "& .MuiInputBase-input": {
                        paddingTop: "0 !important",
                        paddingBottom: "0 !important",
                       alignContent: "center",
                        minHeight: "33px !important",
                        width: "100%",
                      },
                      "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                        borderRadius: "4px !important",
                        paddingLeft: "10px !important",
                        paddingTop: "0 !important",
                        paddingBottom: "0 !important",
                      },
                    }}
                   

                    onBlur={() => {
                      setFocused(null);
                      setRowID(null);
                    }}
                    onFocus={() => {
                      setFocused(task.taskGuid);
                      setRowID(index);
                    }}
                    onChange={(e) => handleChangeDescription(task.id, e.target.value)}
                    disabled={!task.projectGuid || !task.taskGuid}
                    error={isTimeEntryDescriptionMandatory && task.duration > 0 && task.description === ""}
                    required={isTimeEntryDescriptionMandatory && task.duration > 0 && task.description === ""}
                    helperText={
                      isTimeEntryDescriptionMandatory && task.duration > 0 && task.description === "" &&
                      t("myTimesheet.error.description")
                    }
                  />
                </TableCell>

                {/* Duration */}
                <TableCell sx={{ width: "80px", padding: "4px" }}>
                  <TextField
                    value={task.duration}
                    error={Boolean(timeErrors[task.taskGuid])}
                    helperText={timeErrors[task.taskGuid]}
                    sx={{
                      ".MuiInputBase-input": {
                        paddingTop: "0 !important",
                        paddingBottom: "0 !important",
                        textAlign: "center",
                        fontSize: "13px !important",
                        minHeight: "33px !important",
                      },
                    }}
                    inputProps={{
                      inputMode: "decimal",
                      maxLength: 5, // e.g., "999.99"
                    }}
                    disabled={!task.projectGuid || !task.taskGuid}
                    onChange={(e) => handleChangeTime(task.id, e.target.value)}
                  />
                </TableCell>

                {/* Billable Switch */}
                <TableCell
                  sx={{ width: "40px", padding: "4px", display: { xs: "none", sm: "table-cell" } }}
                >
                  <Field
                    as={FormControlLabel}
                    name="billable"
                    control={
                      <Switch
                        size="small"
                        sx={{ marginLeft: "28px" }}
                        checked={task?.billable}
                        disabled={!task.projectGuid || !task.taskGuid}
                        onChange={(e) => handleChangeBillable(task?.id, e.target.checked)}
                      />
                    }
                  />
                </TableCell>

                {/* Add Row Button */}
                <TableCell sx={{ width: "30px", padding: "4px" }}>
                  <IconButton onClick={handleAddNewRow} sx={{ marginLeft: "20px" }} color="primary">
                    <AddCircleRoundedIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    )}
  </TableContainer>
</Box>


    </>
  );
}
